export const initDocumentFilters = () => {
  const documentsSection = document.getElementById('documents');
  const searchInput = document.querySelector('.js-doc-search');
  const filterButtons = Array.from(document.querySelectorAll('.js-doc-filter'));
  const documentItems = Array.from(document.querySelectorAll('.js-doc-item'));
  const emptyState = document.querySelector('.js-doc-empty');
  let activeCategory = 'all';

  if (!documentItems.length || (!searchInput && !filterButtons.length)) {
    return;
  }

  const normalize = (value) => value.trim().toLocaleLowerCase('uk-UA');

  const getCategoryFromHash = () => {
    const hash = decodeURIComponent(window.location.hash.replace(/^#/, ''));

    if (!hash) {
      return '';
    }

    const hashButton = filterButtons.find((button) => button.dataset.filterHash === hash || button.dataset.filter === hash);

    if (hashButton) {
      return hashButton.dataset.filter || 'all';
    }

    if (hash === 'documents') {
      return 'all';
    }

    return '';
  };

  const getHashForCategory = (category) => {
    const button = filterButtons.find((filterButton) => filterButton.dataset.filter === category);

    return button?.dataset.filterHash || `documents-${category}`;
  };

  const scrollDocumentsIntoView = (behavior = 'smooth') => {
    if (!documentsSection) {
      return;
    }

    documentsSection.scrollIntoView({
      behavior,
      block: 'start'
    });
  };

  const syncFilterButtons = () => {
    filterButtons.forEach((filterButton) => {
      const isActive = filterButton.dataset.filter === activeCategory;

      filterButton.classList.toggle('doc-list__filter--active', isActive);
      filterButton.setAttribute('aria-pressed', String(isActive));
    });
  };

  const applyDocumentFilters = () => {
    const query = searchInput ? normalize(searchInput.value) : '';
    let visibleCount = 0;

    documentItems.forEach((item) => {
      const category = item.dataset.category || '';
      const title = normalize(item.dataset.title || item.querySelector('.js-doc-title')?.textContent || '');
      const matchesCategory = activeCategory === 'all' || category === activeCategory;
      const matchesSearch = !query || title.includes(query);
      const isVisible = matchesCategory && matchesSearch;

      item.hidden = !isVisible;

      if (isVisible) {
        visibleCount += 1;
      }
    });

    if (emptyState) {
      emptyState.hidden = visibleCount > 0;
    }
  };

  const setActiveCategory = (category, options = {}) => {
    const nextCategory = category || 'all';
    const hasCategory = filterButtons.some((button) => button.dataset.filter === nextCategory);

    if (!hasCategory) {
      return;
    }

    activeCategory = nextCategory;
    syncFilterButtons();
    applyDocumentFilters();

    if (options.updateHash) {
      const nextHash = getHashForCategory(activeCategory);

      if (window.location.hash !== `#${nextHash}`) {
        window.history.pushState(null, '', `#${nextHash}`);
      }
    }

    if (options.scroll) {
      scrollDocumentsIntoView(options.scrollBehavior);
    }
  };

  filterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      setActiveCategory(button.dataset.filter || 'all', {
        updateHash: true,
        scroll: true
      });
    });
  });

  if (searchInput) {
    searchInput.addEventListener('input', applyDocumentFilters);
  }

  const applyHashFilter = (scrollBehavior = 'smooth') => {
    const hashCategory = getCategoryFromHash();

    if (!hashCategory) {
      return;
    }

    setActiveCategory(hashCategory, {
      scroll: true,
      scrollBehavior
    });
  };

  applyHashFilter('auto');
  syncFilterButtons();
  applyDocumentFilters();

  window.addEventListener('hashchange', () => applyHashFilter());
  window.addEventListener('popstate', () => applyHashFilter('auto'));
};
